import React from 'react';

const ResolveButtons = ({ 
  onCancel, 
  onMarkResolved, 
  className = '' 
}) => {
  return (
    <div className={`flex items-start gap-[10px] self-stretch ${className}`}>
      {/* Cancel Button */}
      <button
        onClick={onCancel}
        className="flex h-10 px-6 py-[10px] flex-col justify-center items-center flex-1 rounded-v3-md bg-[#E0DBFF] hover:bg-[#D1C7FF] transition-colors duration-200"
      >
        <span className="text-center text-[#5745FA] font-inter-variable text-sm font-medium leading-[160%]">
          Cancel
        </span>
      </button>

      {/* Mark as Resolved Button */}
      <button
        onClick={onMarkResolved}
        className="flex h-10 px-6 py-[10px] flex-col justify-center items-center flex-1 rounded-v3-md bg-v3-purple-primary transition-colors duration-200"
      >
        <span className="text-center text-[#fff] font-inter-variable text-sm font-medium leading-[160%]">
          Mark as resolved
        </span>
      </button>
    </div>
  );
};

export default ResolveButtons;
